import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { tbWorkflowSteps } from "../tbModulesData";
import TbImagePlaceholder from "./TbImagePlaceholder";

const stepIcons = [
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4 20c0-4 3.5-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M5 17h14l-1-5H6l-1 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M7 12V8a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="4" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="3" y="14" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
];

const TbHowItWorksSection: React.FC = () => {
  return (
    <section className="wdev-process tb-how" aria-labelledby="tb-how-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="tb-how-title"
            className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
          >
            Taxi App — How It Works?
          </h2>
          <p className="tb-how__lead">
            Curious about how your Taxi App works behind the scenes? Here is a sneak-peek of the
            Taxi App Workflow.
          </p>
        </AnimatedSection>

        <AnimatedSection className="tb-how__visual-wrap" delay={0.1}>
          <TbImagePlaceholder
            variant="devices"
            label="Taxi App Workflow"
            hint="Admin dashboard · User login · Active ride tracking"
            className="tb-how__placeholder"
          />
        </AnimatedSection>

        <div className="wdev-process__timeline">
          <div className="wdev-process__line" aria-hidden="true" />
          {tbWorkflowSteps.map((step, index) => (
            <motion.div
              key={step.title}
              className="wdev-process__step"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              <div className="wdev-process__badge">{String(index + 1).padStart(2, "0")}</div>
              <div className="wdev-process__card">
                <div className="wdev-process__icon">{stepIcons[index]}</div>
                <h3 className="wdev-process__title">{step.title}</h3>
                <p className="wdev-process__desc">{step.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TbHowItWorksSection;
